module.exports = __webpack_public_path__ + "static/img/logo.4533ba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/share/logo.png
// module id = rTu9
// module chunks = 37